import FilterServiceBase from '@/services/FilterServiceBase';
import { IRootState, IFilter } from '@/store/types/IRootState';

const manufacturerFilterMutations = {
    cleanManufacturerFilters(state: IRootState) {
       // FilterServiceBase.mutations.cleanFilters(state.manufacturerFilters.filters);
        state.manufacturerFilters.filters = [];
    },
    checkManufacturerFilter(state: IRootState, filterValue: string) {
        state.manufacturerFilters.filters
            .filter((filter: IFilter) => filter.name === filterValue)
            .forEach((filter: IFilter) => filter.checked = !filter.checked);

        state.currentMaxItems = state.defaultMaxItems;
    },
    populateManufacturerFilters(state: IRootState, partNumbersFilters: any) {
        const manufacturersNames = Object.keys(partNumbersFilters);
        const filters = manufacturersNames.map((manufacturerName: string) => {
        const manufacturer = partNumbersFilters[manufacturerName];
        const partNumbers = Object.keys(manufacturer);
        return {
            type: 'Fabricantes',
            checked: false,
            value: '',
            name: manufacturerName,
            count: partNumbers.length,
            };
        });

        state.manufacturerFilters = {
            filters,
            showAllFilters: true,
            showFilterGroup: true,
        };
    },
    toggleShowAllManufacturerFilters(state: IRootState) {
        state.manufacturerFilters.showAllFilters = !state.manufacturerFilters.showAllFilters;
    },
    toggleShowFilterGroupManufacturerFlag(state: IRootState) {
        state.manufacturerFilters.showFilterGroup = !state.manufacturerFilters.showFilterGroup;
    },
};
export default manufacturerFilterMutations;
